import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { auth, signInWithGoogle } from "./firebase"
import "./static/Login.css"
import Background from "./static/research-login-background.png"
import googleLogo from "./static/google_logo2.png"
import { makeStyles } from "@material-ui/core/styles"
import { Button, CssBaseline, Box, Grid, Typography } from "@mui/material"
import { createTheme, ThemeProvider, styled } from "@mui/material/styles"
import { useAuthState } from "react-firebase-hooks/auth"

const GoogleLogo = styled("img")({
    width: "100%",
    height: "100%",
    borderRadius: "50%"
})

const useStyles = makeStyles(() => ({
    modal: {
        margin: "auto"
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 3, 2),
        paddingRight: 0,
        margin: 10,
        borderRadius: 10
    }
}))

const Copyright = (props) => {
    return (
        <Typography
            variant='body2'
            color='text.secondary'
            align='center'
            {...props}>
            {"Copyright © "}
            <Link color='inherit' href='https://finsoftai.com/'>
                FinSoftAi
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    )
}

const theme = createTheme()

function Offboarding() {
    const navigate = useNavigate()

    return (
        <ThemeProvider theme={theme}>
            <Grid container component='main' sx={{ height: "100vh" }}>
                <CssBaseline />

                <Grid
                    justifyContent={"flex-end"}
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    sx={{
                        backgroundImage: `url(${Background})`,
                        backgroundRepeat: "no-repeat",
                        backgroundColor: "black",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        textAlign: "center"
                    }}>
                    <Box
                        className='login_box'
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "end",
                            height: "100%",
                            width: "100%",
                            backgroundColor: "transparent",
                            pr: "5%"
                        }}>
                        <Box sx={{ mt: 20 }}>
                            <div className='login__container'>
                                <Typography
                                    className='mb-2'
                                    component='h4'
                                    variant='h5'
                                    style={{
                                        color: "#858585",
                                        marginBottom: "1rem"
                                    }}>
                                    Thank you for using the SSi.
                                </Typography>
                                <Typography
                                    variant='body1'
                                    style={{
                                        color: "#ccc",
                                        fontSize: "1rem",
                                        lineHeight: 1.5,
                                        maxWidth: 400,
                                        textAlign: "center"
                                    }}>
                                    Your free trial has ended. To continue
                                    enjoying our services, please reach out to
                                    us at{" "}
                                    <a
                                        href='mailto:contactus@finsoftai.com'
                                        style={{ color: "#4ade80" }}>
                                        contactus@finsoftai.com
                                    </a>
                                    .
                                </Typography>
                            </div>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </ThemeProvider>
    )
}
export default Offboarding
